'use strict';

import React, {Component} from 'react';
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import classnames from "classnames";

import Form from 'react-bootstrap/Form';
import Button from "react-bootstrap/Button";

import optionalChargesStore from "./OptionalChargesStore";
import {Campus} from '@uw-it-sis/lib-react/lib/AppConstants';

class OpChargeWSA extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.store = optionalChargesStore;
    }

    handleChange = (e) => {
        const {name, value} = e.target;
        this.store.updateFormData(name, value);
    }

    submitForm = (e) => {
        e.preventDefault();
        this.props.onSuccess();
    }

    render() {
        const campus = this.props.campus;
        const data = this.store.data;
        const formData = this.store.formData;

        if (campus !== Campus.seattle) {
            return null;
        } else {
            const amount = Number(data.wsl_amt) > 0 ? Number(data.wsl_amt).toFixed(2) : "3.00"; //...default amount if the charge is not in the SDB tables yet

            let form;
            if (data.wsl_update_sw !== "Y") { //...Update deadline for the UW USAS charge has passed already
                let nextButton;
                if (this.props.showButton) {
                    nextButton = <div><Button onClick={this.props.onSuccess}>Continue</Button></div>
                }
                if (data.wsl_sw !== "Y") {
                    form =
                        <>
                            <p>It is past the deadline to make a contribution to Washington Student Association.</p>
                            <p>No, I am not contributing to Washington Student Association.</p>
                            {nextButton}
                        </>
                } else {
                    form =
                        <>
                            <p>It is past the deadline to change your contribution to Washington Student Association.</p>
                            <p>Yes, I am contributing ${amount} to Washington Student Association.</p>
                            {nextButton}
                        </>
                }
            } else {
                let disableButton = formData.WSL !== "Y" && formData.WSL !== "N";
                form =
                    <Form onSubmit={this.submitForm}>
                        <fieldset>
                            <legend className="h3">Washington Student Association contribution:</legend>
                            <Form.Check
                                label={`Yes, add $${amount} for WSA to my bill`}
                                name="WSL"
                                type="radio"
                                value="Y"
                                defaultChecked={formData.WSL === "Y"}
                                onChange={this.handleChange}
                                id="wsa-yes"
                            />
                            <Form.Check
                                label={`No`}
                                name="WSL"
                                type="radio"
                                value="N"
                                defaultChecked={formData.WSL === "N"}
                                onChange={this.handleChange}
                                id="wsa-no"
                            />
                        </fieldset>
                        <Button aria-disabled={disableButton} type="submit" className={classnames({"disabled": disableButton})}>Continue</Button>
                    </Form>
            }

            return (
                <>
                    <h4 className="h2">Washington Student Association</h4>
                    <p>
                        The <a href='http://www.wastudents.org/' target='_blank'>Washington Student Association</a> (WSA) is a voluntary, independent
                        organization of university students whose purpose is to influence the Washington State Legislature and others on higher education
                        matters of special interest to students. If you choose to contribute to WSA, ${amount} will be included on your tuition statement.
                        Additional information may be obtained through the <a href='http://www.wastudents.org/' target='_blank'>WSA website</a>.
                    </p>
                    {form}
                </>
            )
        }
    }
}

OpChargeWSA.propTypes = {
    campus: PropTypes.string.isRequired,
    showButton: PropTypes.bool
}

OpChargeWSA.defaultProps = {
    showButton: false
}

export default observer(OpChargeWSA);